import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Reveal from '../components/Reveal';
import { useLanguage } from '../lib/LanguageContext';
import { GALLERY_STATEMENT } from '../lib/localizedContent';

const AboutPage = () => {
  const { language } = useLanguage();
  const sections = GALLERY_STATEMENT[language];
  const ro = language === 'ro';

  return (
    <div className="bg-bone text-charcoal min-h-screen" data-testid="about-page">
      <Header />
      <main>
        <section className="pt-36 md:pt-44 lg:pt-52 px-6 md:px-12 lg:px-16 pb-16 md:pb-24">
          <div className="grid grid-cols-12 gap-x-6 gap-y-10">
            <Reveal delay={0.1} className="col-span-12">
              <nav className="text-[11px] tracking-eyebrow uppercase text-charcoal/50 mb-6 flex gap-2">
                <Link to="/">{ro ? 'Acasă' : 'Home'}</Link><span>/</span><span>{ro ? 'Despre' : 'About'}</span>
              </nav>
              <h1 className="font-sans font-extrabold leading-[0.9] text-6xl sm:text-7xl md:text-[9vw] lg:text-[8vw]">Dimir and Son Gallery</h1>
              <p className="mt-8 max-w-3xl text-xl md:text-3xl leading-tight">
                {ro ? 'Artă contemporană dincolo de reprezentare.' : 'Contemporary art beyond representation.'}
              </p>
            </Reveal>
          </div>
        </section>

        <section className="px-6 md:px-12 lg:px-16 pb-20 md:pb-28">
          <Reveal>
            <div className="relative w-full aspect-[16/8] overflow-hidden bg-beige">
              <img src="/images/image5.png" alt={ro ? 'Interiorul galeriei' : 'Gallery interior'} className="absolute inset-0 w-full h-full object-cover" />
            </div>
          </Reveal>
        </section>

        <section className="border-t border-charcoal px-6 md:px-12 lg:px-16 pb-24 md:pb-36">
          {sections.map((section, index) => (
            <Reveal key={section.title}>
              <article className="grid grid-cols-12 gap-x-6 gap-y-5 py-12 md:py-16 border-b border-charcoal/30">
                <div className="col-span-12 md:col-span-1 text-[11px] tracking-eyebrow text-charcoal/50">{String(index + 1).padStart(2, '0')}</div>
                <h2 className="col-span-12 md:col-span-4 font-sans font-extrabold text-3xl md:text-4xl leading-tight">{section.title}</h2>
                <p className="col-span-12 md:col-span-6 md:col-start-7 text-base md:text-lg leading-relaxed text-charcoal/75">{section.text}</p>
              </article>
            </Reveal>
          ))}
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
